import gql from "graphql-tag"

const CREATE_SUKA = gql `
  mutation sukaCreate($input: SukaCreateInput!){
    sukaCreate(input: $input){
      id,
      pengguna{
        nama
        jabatan{
            nama
          }
      }
    }
  }
`

const DELETE_SUKA = gql `
  mutation sukaDelete($id: ID!){
    sukaDelete(id: $id){
      id
    }
  }
`

export {
  CREATE_SUKA,
  DELETE_SUKA
}
